import { TypedDocumentNode, gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Skeleton } from '@sorare/core/src/atoms/loader/Skeleton';

import { CompetitionDetailsGameplayDescription_LeaderboardInterface } from './__generated__/index.graphql';

type Props = {
  leaderboard?: CompetitionDetailsGameplayDescription_LeaderboardInterface | null;
};

export const Description = ({ leaderboard }: Props) => {
  if (!leaderboard) {
    return <Skeleton loading />;
  }
  return (
    <Vertical>
      {leaderboard?.descriptions.map(d => <p key={d}>{d}</p>)}
    </Vertical>
  );
};

Description.fragments = {
  LeaderboardInterface: gql`
    fragment CompetitionDetailsGameplayDescription_LeaderboardInterface on LeaderboardInterface {
      slug
      descriptions
    }
  ` as TypedDocumentNode<CompetitionDetailsGameplayDescription_LeaderboardInterface>,
};
